export default {
  presenter: 'benes',
  title: 'ČVUT SÚZ reinstall - rok a půl poté',
  subtitle: 'mírně pokročilí',
  text: `
Krátké povídání o převzetí sítě ČVUT SÚZ (Správa účelových zařízení):
* migrace ze standalone Hyper-V hypervizorů na QEMU nad GlusterFS a LXC
* rekonstrukce síťové infrastruktury - od hubů k JunOS a Ansible
* přechod od analogových telefonů na VoIP
* výhled do budoucna
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/benes-reinstall.js